var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#ECF7F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3905 34.8563C26.3905 35.3843 24.8035 35.8148 24.2275 35.8148C23.65 35.8148 22.0645 35.3843 22.0645 34.8563L23.1805 23.4683C23.1805 22.9388 23.65 22.5098 24.2275 22.5098C24.805 22.5098 25.2745 22.9388 25.2745 23.4683L26.3905 34.8563Z",
    fill: "#009248"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9421 17.154C24.9421 17.574 24.6271 17.913 24.2401 17.913C23.8501 17.913 23.5366 17.574 23.5366 17.154V12.759C23.5366 12.3405 23.8501 12 24.2401 12C24.6271 12 24.9421 12.3405 24.9421 12.759V17.154Z",
    fill: "#009248"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2431 25.306C16.8456 25.5805 16.3401 25.534 16.1091 25.2055C15.8841 24.877 16.0176 24.385 16.4136 24.112L20.5701 21.232C20.9661 20.959 21.4746 21.0025 21.7026 21.331C21.9306 21.661 21.7956 22.1515 21.3981 22.426L17.2431 25.306Z",
    fill: "#009248"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0403 23.8297C32.2333 23.9482 32.3713 24.1384 32.4242 24.3586C32.4771 24.5788 32.4404 24.811 32.3223 25.0042C32.1956 25.1921 31.9994 25.322 31.7769 25.3653C31.5544 25.4086 31.3238 25.3618 31.1358 25.2352L26.8818 22.5007C26.7861 22.442 26.7028 22.365 26.6368 22.2741C26.5708 22.1833 26.5234 22.0803 26.4972 21.9711C26.471 21.8619 26.4666 21.7486 26.4842 21.6377C26.5018 21.5268 26.5411 21.4204 26.5998 21.3247C26.7268 21.1378 26.9225 21.0088 27.1442 20.9658C27.366 20.9228 27.5957 20.9693 27.7833 21.0952L32.0403 23.8297Z",
    fill: "#009248"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4707 19.4043H24.8298V20.8113H23.4707V19.4043Z",
    fill: "#009248"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachines);
export default __webpack_public_path__ + "static/media/machines.96dbf9aabd8769ef08dff58578039fa2.svg";
export { ForwardRef as ReactComponent };